import { Component, OnInit } from '@angular/core';
import { Route, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { signedInSelector } from 'projects/header-themes/src/lib/domain/facades/store/HeaderThemes.selectors';
import { HeadersFacade, UPDATE_CART_DISPLAY_STATUS_ACTION } from 'projects/header-themes/src/public-api';

@Component({
  selector: 'mobile-footer-theme1',
  templateUrl: './footer-theme1.component.html',
  styleUrls: ['./footer-theme1.component.css']
})
export class MobileFooterTheme1Component implements OnInit {
  iconColor: string = 'gray'; // Set the default color

  constructor(private store:Store,private facades:HeadersFacade,private router:Router) { }
  activeTab: string = 'home'; // Set 'home' as the initial active tab
  is_signed_in: boolean = false;

  changeTab(tab: string) {
    this.activeTab = tab;
    setTimeout(() => {
      this.navigate_top()
    }, 500);
  }
  ngOnInit(): void {}

  open_cart()
  {
    this.store?.dispatch(new UPDATE_CART_DISPLAY_STATUS_ACTION(true));
  }
  showSearchBar(){
    this.facades?.toggle_mobile_search_view_state(true);

  }
  switchToProfile(){
    this.store.select(signedInSelector).subscribe(signedIn => {
      this.is_signed_in = signedIn;
      console.log('User is signed in:', signedIn); // This should reflect the current signed-in state
    });

    if (this.is_signed_in){

      this.router?.navigate(['my-account', 'my-profile']);
    }else {
      this.facades.ShowSignInModal()


    }

}
navigate_top() {
  const section = document.getElementById('scrolltotop');
  section?.scrollIntoView({ behavior: 'smooth' });

}
}
